import { Route } from '@angular/router';
import {TenderContractDashboardIndexAnalysisGraphComponent} from '../../../../../../../../pages';

export const graphRoute: Route = {
    path: 'graph',
    component: TenderContractDashboardIndexAnalysisGraphComponent,
};
